(function () {
  const initFaq = (section) => {
    if (section.dataset.amFaqReady === 'true') {
      return;
    }

    section.dataset.amFaqReady = 'true';

    const items = Array.from(section.querySelectorAll('.am-faq__item'));

    const syncExpandedState = (details) => {
      const summary = details.querySelector('.am-faq__summary');
      details.toggleAttribute('data-open', details.open);

      if (summary) {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }
    };

    items.forEach((details) => {
      syncExpandedState(details);

      details.addEventListener('toggle', () => {
        if (details.open) {
          items.forEach((openDetails) => {
            if (openDetails !== details && openDetails.open) {
              openDetails.open = false;
              syncExpandedState(openDetails);
            }
          });
        }

        syncExpandedState(details);
      });
    });
  };

  const initAllFaqs = () => {
    document.querySelectorAll('[data-am-faq]').forEach(initFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFaqs, { once: true });
  } else {
    initAllFaqs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches('[data-am-faq]')
      ? event.target
      : event.target.querySelector('[data-am-faq]');

    if (section) {
      initFaq(section);
    }
  });
})();
